import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent } from "@/components/ui/card";

function SelectField({ label, value, onChange, options, testid, allowEmpty = true, emptyLabel = "—" }) {
  return (
    <div className="space-y-1.5">
      <Label>{label}</Label>
      <select
        className="w-full border border-slate-300 rounded-md px-3 h-11 md:h-9 text-base md:text-sm bg-white min-h-[44px]"
        value={value || ""}
        onChange={(e) => onChange(e.target.value || null)}
        data-testid={testid}
      >
        {allowEmpty && <option value="">{emptyLabel}</option>}
        {options.map((s) => <option key={s.id} value={s.id}>{s.full_name}</option>)}
      </select>
    </div>
  );
}

/** Tab "Profissionais" — surgeon, assistant, 3rd surgeon, anesthesiologist, instrument tech. */
export default function ProfissionaisTab({
  edit, setEdit, surgeons, anesths, iteches,
  changeReason, setChangeReason, savePayload,
}) {
  return (
    <Card><CardContent className="p-6 grid grid-cols-1 md:grid-cols-2 gap-4">
      <SelectField
        label="Cirurgião"
        value={edit.surgeon_id}
        onChange={(v) => setEdit({ ...edit, surgeon_id: v })}
        options={surgeons}
      />
      <SelectField
        label="Cirurgião Auxiliar"
        value={edit.assistant_surgeon_id}
        onChange={(v) => setEdit({ ...edit, assistant_surgeon_id: v })}
        options={surgeons}
      />
      <div className="space-y-1.5">
        <Label>3º Cirurgião <span className="text-slate-400 text-xs">(opcional)</span></Label>
        <select
          className="w-full border border-slate-300 rounded-md px-3 h-11 md:h-9 text-base md:text-sm bg-white min-h-[44px]"
          value={edit.assistant_surgeon_2_id || ""}
          onChange={(e) => setEdit({ ...edit, assistant_surgeon_2_id: e.target.value || null })}
          data-testid="select-surgeon-3"
        >
          <option value="">— (apenas 2 cirurgiões neste caso)</option>
          {surgeons.map((s) => <option key={s.id} value={s.id}>{s.full_name}</option>)}
        </select>
        <p className="text-[11px] text-slate-500">
          Deixe vazio para casos com apenas <strong>2 cirurgiões</strong> (o valor é dividido por 2).
          Se preencher, o caso terá <strong>3 cirurgiões</strong> e o valor é dividido em 3 partes iguais.
        </p>
      </div>
      <SelectField
        label="Anestesista"
        value={edit.anesthesiologist_id}
        onChange={(v) => setEdit({ ...edit, anesthesiologist_id: v })}
        options={anesths}
      />
      <SelectField
        label="Instrumentador"
        value={edit.instrument_technician_id}
        onChange={(v) => setEdit({ ...edit, instrument_technician_id: v })}
        options={iteches}
      />

      <div className="md:col-span-2 space-y-1.5">
        <Label>Motivo da alteração</Label>
        <Input value={changeReason} onChange={(e) => setChangeReason(e.target.value)} placeholder="Ex: Cirurgião trocado no dia da cirurgia" />
      </div>
      <div>
        <Button onClick={savePayload} className="bg-blue-700 hover:bg-blue-800 h-11 md:h-9 w-full sm:w-auto" data-testid="btn-save-team">Salvar profissionais</Button>
      </div>
    </CardContent></Card>
  );
}
